import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11decdba"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_2 = {
  ref: "datatable",
  class: "table table-striped table-hover"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ชื่อจังหวัด"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ชื่อภาษาอังกฤษ"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "รหัส"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "เขตเศรษฐกิจพิเศษ")
  ])
], -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-dot-circle me-2" }, null, -1))
const _hoisted_6 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.provinces, (province, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index,
                class: "row-hover",
                onClick: ($event: any) => (_ctx.editClick(province.id))
              }, [
                _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                _createElementVNode("td", null, [
                  _hoisted_5,
                  _createTextVNode(_toDisplayString(province.name), 1)
                ]),
                _createElementVNode("td", null, _toDisplayString(province.englishName), 1),
                _createElementVNode("td", null, _toDisplayString(province.iso), 1),
                _createElementVNode("td", _hoisted_6, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["far", {
                  'fa-circle text-secondary': !province.isSpecialEconomicZone,
                  'fa-check-circle text-success': province.isSpecialEconomicZone
                }])
                  }, null, 2)
                ])
              ], 8, _hoisted_4))
            }), 128))
          ])
        ], 512)
      ]))
}